'use strict';


import { Report } from './QAReport';
import { settingsData, threeJsVariables } from '../../settings';
import { QAFloorValidator } from './QAFloorValidator';
import { LinearSRGBColorSpace, WebGLRenderer } from 'three';

export class VantagesQA extends Report{
	constructor () {
		super('Vantages');
		
		this.crm = settingsData.allCrmData;
		this.bundleVantages = threeJsVariables.bundleConfig.vantage;
		this.floorValidator = null;
		this.renderer = new WebGLRenderer({
			antialias: false,
			autoClear: true,
			stencil: false,
			depth: false,
		});
		this.renderer.shadowMap.enabled = false;
		this.renderer.sortObjects = false;
		this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
		this.renderer.setSize(334,216);
		this.renderer.outputColorSpace = LinearSRGBColorSpace;
	}
	
	initFloorValidator() {
		this.removeFloorValidator();
		this.floorValidator = new QAFloorValidator(this.renderer);
		this.floorValidator.build();
	}
	
	removeFloorValidator() {
		if (this.floorValidator) {
			this.floorValidator.save();
			this.floorValidator.destroy();
			this.floorValidator = null;
		}
	}
	
	validate() {
		this.jsonReport = [];
		const buildings = [...new Set(this.crm.map(apt => apt.buildingEngineId))];
		buildings.forEach(buildingId => {
			const bundleVantages = this.bundleVantages[buildingId];
			if (!bundleVantages) {
				this.addError(buildingId,`No available photographic vantages.`,null);
			}
			
			const apartments = this.crm.filter(apt => apt.buildingEngineId === buildingId);
			apartments.forEach(apt => {
				if (apt.assets.vantage.length === 0) {
					const photoVantages = bundleVantages?.find(vApt =>  vApt.name === apt.engineId);
					if (!photoVantages || (photoVantages && !photoVantages.url)) {
						this.addError(apt,`empty vantage URL.`);
					}
				}
			});
		});
		
		const ls = localStorage.getItem('floorValidator');
		if (ls) {
			const data = JSON.parse(ls);
			Object.entries(data).forEach(([building,floors]) => {
				Object.values(floors).forEach(floor => {
					const invalid = floor.filter(apt => apt.valid === false);
					invalid.forEach(data => {
						this.addError(`Building: ${building}, Apt: ${data.apt}`,data.message);
					});
				});
			});
		}
		
		this.normalize();
		this.showReport();
	}
	
	normalize () {
		if (!this.log.length) {
			this.jsonReport.push('OK');
		} else {
			this.log.forEach(errorData => {
				if (typeof errorData.apt === 'string') {
					this.jsonReport.push(`${errorData.apt} - ${errorData.message}`);
				} else {
					const normalizeData = super.normalize(errorData.apt);
					this.jsonReport.push(`${normalizeData} - ${errorData.message}`);
				}
			});
		}
	}
	
}
